import { 
    Stack, 
    TextField, 
    MenuItem, 
    IconButton, 
    Button 
} from "@mui/material";
import { Add, DeleteOutline } from "@mui/icons-material";
import NumberControl from "components/NumberControl";


const InventoryEditor = ({ rows, products, onUpdate, onAdd, onRemove }) => (
    <>
        {rows.map((row, idx) => (
            <Stack 
                key={idx} 
                direction="row" 
                alignItems="center" 
                spacing={1} 
                mb={1}
            >
                <TextField
                    size="small"
                    select
                    label="Product"
                    value={row.productId}
                    onChange={(e) => onUpdate(idx, "productId", e.target.value)}
                    sx={{ flex: 1 }}
                >
                    {products.map((p) => (
                        <MenuItem key={p._id} value={p._id}>
                            {p.productName}
                        </MenuItem>
                    ))}
                </TextField>
                <NumberControl
                    min={0}
                    max={9999}
                    value={row.allocatedQty}
                    onChange={(v) => onUpdate(idx, "allocatedQty", v)}
                    textFieldWidth={56}
                />
                <IconButton size="small" color="error" onClick={() => onRemove(idx)}>
                    <DeleteOutline fontSize="small" />
                </IconButton>
            </Stack>
        ))}
        <Button size="small" startIcon={<Add />} onClick={onAdd}>
            Add Product
        </Button>
    </>
);

export default InventoryEditor;
